import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);
  // useEffect(() => {
  //   // Ensure it runs after render
  //   setTimeout(() => {
  //     window.scrollTo(0, 0); // instant scroll
  //     window.scrollTo({ top: 0, behavior: "smooth" }); // smooth fallback
  //   }, 0);
  // }, [pathname]);

  return null;
};

export default ScrollToTop;
